import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { SegmentEmployeesApiResponse } from "../model/SegmentEmployee";

interface SegmentEmployeesRequest {
  segmentId: number;
  search?: string;
  page?: number;
  page_size?: number;
}

export const SegmentEmployeesApiService = async (
  request: SegmentEmployeesRequest
): Promise<SegmentEmployeesApiResponse> => {
  const { segmentId, ...params } = request;
  const url = `/segments/${segmentId}/employees/`;
  const { data } = await axios.get(url, { params });
  if (data?.results) {
    return data;
  }
  const results = Array.isArray(data) ? data : [];
  return { results, count: results.length, pages: results.length > 0 ? 1 : 0 };
};

const useSegmentEmployeesApiService = (
  request: SegmentEmployeesRequest,
  enabled = true
): UseQueryResult<SegmentEmployeesApiResponse, AxiosError> =>
  useQuery<SegmentEmployeesApiResponse, AxiosError>(
    ["SegmentEmployeesApiService", ...Object.values(request)],
    () => SegmentEmployeesApiService(request),
    { keepPreviousData: true, enabled }
  );

export default useSegmentEmployeesApiService;
